import { useEffect, useState } from "react";
import imageLogo from "../../webroot/images/login-logo-2.svg";
import logo from "../../webroot/images/logo.svg";
import GoogleLogin from "./GoogleLogin";
import { useTranslation } from "react-i18next";
import welcomeLogo from "../../webroot/images/welcomeLogo.svg";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useApolloClient } from "@apollo/client";
import { toast } from "react-toastify";
import { executeGraphQLQuery } from "../../common/executeGraphQLQuery";
import { GOOGLE_EMAIL } from "../../services/login.gql";
import { loggedIn } from "../../store/reducers/userReducer";
import { useDispatch } from "react-redux";
import FullPageLoader from "../common/FullPageLoader";

function Login() {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation("common");
  const history = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const client = useApolloClient();

  useEffect(() => {
    const loggedInUser = JSON.parse(localStorage.getItem("user_information"));
    if (loggedInUser && loggedInUser.user_data) {
      history("/dashboard");
    }
  }, [history]);

  useEffect(() => {
    const userDataParam = searchParams.get("userdata");
    if (userDataParam) {
      try {
        const parsedData = JSON.parse(decodeURIComponent(userDataParam));
        console.log(parsedData);
        if (
          (!parsedData.domain && parsedData.email) ||
          parsedData.domain !== "Invalid"
        ) {
          setLoading(true);
          executeGraphQLQuery(GOOGLE_EMAIL(parsedData.email), client).then(
            async (result) => {
              const loginData = result?.data?.login_with_email;
              setLoading(false);
              if (loginData && !loginData?.is_error) {
                localStorage.setItem("loggedIn", "1");
                localStorage.setItem(
                  "user_information",
                  JSON.stringify(loginData)
                );

                dispatch(loggedIn(loginData));
                history("/dashboard");
              } else {
                toast.error("User does not exist!");
                history("/login");
              }
            }
          );
        } else {
          toast.error("Domain is Invalid");
          const urlParams = new URLSearchParams(location.search);
          if (urlParams.has("userdata")) {
            urlParams.delete("userdata");
            const newUrl = `${location.pathname}`;
            history(newUrl);
          }
        }
      } catch (error) {
        console.error(`Error while getting userDataParams:`, error);
      }
    }
  }, [searchParams, client, dispatch, history, location.pathname, location.search]);

  return (
    <>
      <FullPageLoader show={loading} />
      <div className="container-fluid">
        <div className="row">
          <div className="login-outer">
            <div className="login-left-panel">
              <div className="login-bg">
                <div className="logo-img">
                  {<img src={logo} className="" alt="logo" />}
                </div>
                <div className="logo-img">
                  {<img src={welcomeLogo} className="" alt="logo" />}
                </div>
                <div className="login-txt">
                  <span></span>
                </div>
                {<img src={imageLogo} className="login-bg-img" alt="logo-bg" />}
              </div>
            </div>
            <div className="login-right-panel">
              <div className="login-heading">
                <h2>{t("FORM.LOGIN")}</h2>
              </div>
              <GoogleLogin />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
